import { createContext, ReactNode, useState, useEffect, useContext } from 'react';
import jwtDecode from 'jwt-decode';
import AuthStorage from '@/services/auth/storage';

const UserContext = createContext<any>(null);

type Props = {
    children?: ReactNode;
};

interface IUser {
    restaurantId: string | null;
    posVendor: string | null;
    userData?: {
        name?: string | null;
        role?: string | null;
        email?: string | null;
    };
}

export function UserContextProvider({ children }: Props) {
    const [user, setUser] = useState<IUser | null>(null);
    useEffect(() => {
        const token = AuthStorage.getAccessToken();
        if (!token) {
            return;
        }

        setUser({
            ...jwtDecode(token),
            restaurantId: AuthStorage.getRestaurantId(),
            posVendor: AuthStorage.getPosVendor(),
            userData: {
                name: AuthStorage.getUsername(),
                role: AuthStorage.getUserRole(),
            },
        });
    }, []);

    // eslint-disable-next-line react/jsx-no-constructed-context-values
    return <UserContext.Provider value={{ user, setUser }}> {children} </UserContext.Provider>;
}

export const useUserContext = () => useContext(UserContext);
